import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoginForm from "../components/LoginForm";
import axiosInstance from "../api/axiosInstance";

function LoginPage() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    let newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = "اسم المستخدم مطلوب";
    }

    if (!formData.password) {
      newErrors.password = "كلمة المرور مطلوبة";
    } else if (formData.password.length < 6) {
      newErrors.password = "كلمة المرور يجب أن تكون 6 أحرف على الأقل";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

    setErrors({
      ...errors,
      [e.target.name]: ""
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setIsSubmitting(true);

    try {
        const response = await axiosInstance.post("auth/login", formData);

        const { token, user } = response.data;

        // حفظ البيانات
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));

        toast.success("تم تسجيل الدخول بنجاح ✅");
        navigate("/orders");

      } catch (error) {
        if (error.response) {
        const status = error.response.status;
        if (status === 401) {
          setErrors({
            general: "اسم المستخدم أو كلمة المرور خاطئة"
          });
          toast.error("فشل تسجيل الدخول، تحقق من صحة البيانات ⚠️");
        } else if (status === 400) {
          setErrors({
            general: "الرجاء ملء جميع الحقول المطلوبة"
          });
        }} else if (error.request) {
          toast.error("خطأ في الاتصال بالخادم ⚠️");
        } else {
          toast.error("حدث خطأ غير متوقع، حاول مرة أخرى ⚠️");
        }
        setIsSubmitting(false);
      }
};

  return (
    <LoginForm
      formData={formData}
      errors={errors}
      isSubmitting={isSubmitting}
      onChange={handleChange}
      onSubmit={handleSubmit}
    />
  );
}

export default LoginPage;
